import { render } from "./SearchTransferBookProductModal.vue?vue&type=template&id=3a520021"
import script from "./SearchTransferBookProductModal.vue?vue&type=script&lang=js"
export * from "./SearchTransferBookProductModal.vue?vue&type=script&lang=js"

import "./SearchTransferBookProductModal.vue?vue&type=style&index=0&id=3a520021&lang=css"
script.render = render

export default script